import {
  HttpErrorResponse,
  HttpHandler,
  HttpHeaderResponse,
  HttpInterceptor,
  HttpProgressEvent,
  HttpRequest,
  HttpResponse,
  HttpSentEvent,
  HttpUserEvent
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@pg-app/core/services/auth.service';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { CommonMessages } from '@pg-app/shared/constants/common-messages';
import { environment } from '@pg-env/environment';

@Injectable()
export class CustomHttpInterceptor implements HttpInterceptor {
  constructor(private auth: AuthService, private router: Router, private toastrService: ToastrService) { }
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any>> {
    const useLocalHandleException = req.headers.get('useLocalHandleException');
    req = req.clone({
      headers: req.headers.set('tenantId', environment.tenantId)
    });
    if (useLocalHandleException) {
      req = req.clone({
        headers: req.headers.delete('useLocalHandleException')
      });
    }
    return next.handle(req).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err && err.status === 401) {
          this.auth.logout(false);

          this.router.navigate(['/auth', 'login']);
          this.toastrService.error('You are not authorized or your token has expired.');
          return of(null);
        } else if (!useLocalHandleException) {
          let message = CommonMessages.errorMessageAPI;
          if (err && err.error) {
            const errors = typeof err.error === 'string' ? JSON.parse(err.error) : err.error;
            if (errors.messages?.length > 0) {
              message = errors.messages[0];
            }
          }
          this.toastrService.error(message);
        }

        throw err;
      })
    );
  }
}
